import { FC } from 'react'
import AuthLayout from '~/app/components/layouts/AuthLayout'
import SignInForm from '~/app/components/modules/SignIn'
import Text from '~/app/components/utils/Text/Text'

const SignInPage: FC = () => {
  return (
    <AuthLayout>
      <div className="flex-center flex-col gap-8">
        <Text type="headline-4" color="800" align="center">
          Sign in
        </Text>
        <SignInForm />
      </div>
    </AuthLayout>
  )
}

export default SignInPage
